import { enMessages } from "./en";

function pseudoLocalize(value: string): string {
  const expanded = value.replace(/[aeiou]/gi, "$&$&");
  return `[!! ${expanded} !!]`;
}

export const pseudoMessages = Object.fromEntries(
  Object.entries(enMessages).map(([key, value]) => [key, pseudoLocalize(value)]),
) as typeof enMessages;
